
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/just",
      function () {
        return require("private-next-pages/just.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/just"])
      });
    }
  